import { useEffect } from "react";
import { useLoadingIndicatorStore } from "../store/use-loading-indicator-store";

export function useLoadingIndicator(isShow: boolean) {
  const { setLoading } = useLoadingIndicatorStore();

  useEffect(() => {
    setLoading(isShow);

    // 컴포넌트 언마운트 시 로딩 해제
    return () => {
      setLoading(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);
}
